import React from "react";
import ReactDOM from "react-dom";

// Helper to darken tag text color for contrast
function darkenColor(hex, amount = 0.4) {
  if (!hex || !hex.startsWith("#")) return "#333";
  const num = parseInt(hex.slice(1), 16);
  let r = (num >> 16) & 255;
  let g = (num >> 8) & 255;
  let b = num & 255;

  r = Math.floor(r * (1 - amount));
  g = Math.floor(g * (1 - amount));
  b = Math.floor(b * (1 - amount));

  return `rgb(${r}, ${g}, ${b})`;
}

const TagOverflowTooltip = ({ tags, anchorRef }) => {
  if (!anchorRef?.current || tags.length === 0) return null;

  const rect = anchorRef.current.getBoundingClientRect();

  return ReactDOM.createPortal(
    <div
      className="fixed z-[9999] bg-white shadow-md rounded-md p-3 border border-gray-200"
      style={{
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX,
        maxWidth: "300px",
        width: "max-content",
      }}
    >
      {tags.map((tag) => (
        <div
          key={tag.id}
          className="flex items-center gap-1 px-3 py-1 rounded-full text-[14px] font-[600] font-[Outfit] whitespace-nowrap mb-2 last:mb-0"
          style={{
            backgroundColor: `${tag.color}1A`,
            border: `2px solid ${tag.color}`,
            color: darkenColor(tag.color),
          }}
        >
          {tag.name}
        </div>
      ))}
    </div>,
    document.body
  );
};

export default TagOverflowTooltip;
